'use client';

import { ShowStyles } from '@/enums/show-styles';
import { useUpdateLayoutContext } from '@/hooks/state/layout';
import { useEffect } from 'react';

type LayoutProviderProps = {
  initialHideLayout: boolean;
};

export const LayoutProvider = ({ initialHideLayout }: LayoutProviderProps): null => {
  const { mutate: setHideLayout } = useUpdateLayoutContext();

  useEffect(() => {
    setHideLayout({ hideLayout: initialHideLayout, showStyles: ShowStyles.Main });
  }, [initialHideLayout, setHideLayout]);

  return null;
};
